import SearchComp from "components/Searchcomponent";
import React from "react";

export const Fillter = ({ fillter, onSearchChange }) => {
  return (
    <div
      className="col-md-12 col-xs-12 col-lg-12 col-sm-12 d-flex activated-ledger d-flex flex-column flex-lg-row justify-content-between mt-3 mb-3"
      style={{ padding: 0 }}
    >
      <div
        className="sub-header-functions  col-md-4 col-xs-12 col-lg-4 col-sm-12"
        style={{ padding: 0 }}
      >
        <SearchComp
          value={fillter?.search}
          setSearchText={onSearchChange}
          placeholder="Search by segment name"
        />
      </div>
    </div>
  );
};
